import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=02882d5a&scoped=true&"
import script from "./Staff.vue?vue&type=script&lang=ts&"
export * from "./Staff.vue?vue&type=script&lang=ts&"
import style0 from "./Staff.vue?vue&type=style&index=0&id=02882d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02882d5a",
  null
  
)

export default component.exports